import ImageCDN from '@components/skeleton/ImageCDN'
import { ImageDefault } from '@components/utils/Utils'
import { IImageComponentResponse } from '@customTypes/componentResponses'
import { IMAGE_SIZE } from '@libs/cards/utils/constants'
import GridGallery, { GridGalleryProps } from '@libs/slider/GridGallery'
import { ITag } from '@modules/requestAQuote/components/TripPreferences'
import { useMemo } from 'react'
import CardHeaderAccessories from './components/CardHeaderAccessories'

interface IGalleryHeader {
  responsiveGridConfig: GridGalleryProps['responsiveGridConfig']
  title?: string
  images?: string[] | IImageComponentResponse[] | null
  imageSize?: string
  tags?: ITag[]
  url?: string
  likeHandler?: any
  blurb?: string
  onGalleryClick?: () => void
}

const GalleryHeader = ({
                         responsiveGridConfig,
  tags,
  title,
  imageSize,
  images,
  onGalleryClick,
}: IGalleryHeader): JSX.Element => {
  const imageComponents = useMemo(() => {
    return images?.map((image, index) => {
      return (
        <div
          className='relative min-w-[calc(100vw_-_20px)] px-[10px] desktop:min-w-full desktop:pr-0'
          key={index}
        >
          <div
            className={`relative w-full rounded-3xl ${
              IMAGE_SIZE[imageSize ?? 'default']?.css
            }`}
          >
            <ImageCDN
              className='rounded-3xl'
              src={ImageDefault(image)}
              height={IMAGE_SIZE[imageSize ?? 'default']?.size.height}
              width={IMAGE_SIZE[imageSize ?? 'default']?.size.width}
              layout='fill'
              objectFit='cover'
              alt={title}
              priority={false}
            />
          </div>
        </div>
      )
    })
  }, [images])

  return (
    <div
      className={`relative drop-shadow-lg ${
        IMAGE_SIZE[imageSize ?? 'default']?.css
      }`}
    >
      <div className='relative ml-[0.6rem] h-full min-w-[20.25rem] desktop:mx-0'>
        <GridGallery
          components={imageComponents}
          responsiveGridConfig={responsiveGridConfig}
        />
        <div className='pointer-events-none absolute top-0 left-[0.6rem] z-10 h-full w-[calc(100vw_-_20px)] desktop:w-full'>
          <CardHeaderAccessories
            onGalleryClick={onGalleryClick}
            tags={tags}
            isGalleryHeader
          />
        </div>
      </div>
    </div>
  )
}

export default GalleryHeader
